import { Calendar } from "primereact/calendar";
import ErrorMessage from "./ErrorMessage";
import { useFormikContext, getIn } from "formik";

export type CustomDatepickerProps = {
  id: string;
  label: string;
  dateFormat?: string;
  showIcon?: boolean;
  required?: boolean;
  [key: string]: any;
};

const CustomDatepicker = ({
  id,
  label,
  dateFormat = "dd.mm.yy",
  showIcon = true,
  required,
  ...props
}: CustomDatepickerProps) => {
  const formik = useFormikContext<any>();

  const handleDateChange = (e: any) => {
    if (!e.value) {
      formik.setFieldValue(id, null);
      return;
    }
    const adjustedDate = new Date(e.value.getTime() - e.value.getTimezoneOffset() * 60000);
    formik.setFieldValue(id, adjustedDate);
  };

  const value = getIn(formik.values, id);

  return (
    <div className="flex flex-column gap-2 mb-2">
      <label htmlFor={`dp-${id}`}>
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <Calendar
        id={id}
        inputId={`dp-${id}`}
        value={value instanceof Date ? value : value ? new Date(value) : null}
        onChange={handleDateChange}
        onBlur={formik.handleBlur}
        readOnlyInput={false}
        showIcon={showIcon}
        dateFormat={dateFormat}
        locale="bg"
        appendTo={typeof document !== "undefined" ? document.body : undefined}
        {...props}
      />
      <ErrorMessage id={id} formik={formik} />
    </div>
  );
};

export default CustomDatepicker;
